import emailjs from '@emailjs/browser';
import React, { useRef } from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import './Mailer.css'

export default function Mailer() {
  const form = useRef();
  const [status, setStatus] = useState('');
  const [error, setError] = useState(null);
  const [values, setValues] = useState({
      name: "",
      email: "",
      role: "",
      message: "",
  });

  const handleChange = (e) => {
      setValues((prevValues) => ({
          ...prevValues,
          [e.target.name]: e.target.value,
      }));
      setError(null); // Clear error when user types
  };

  const sendEmail = (e) => {
    e.preventDefault();

    // Validation: Check if all fields are filled
    if (!values.name || !values.email || !values.role || !values.message) {
        setError("すべての項目を入力してください。");
        return; // Stop function execution
    }

    if (!form.current) return;

    emailjs
        .sendForm("service_txre9kj", "template_gny38gb", form.current, "bLFwVPqsJTENMCJpc")
        .then(
            (result) => {
                console.log(result.text);
                setStatus("SUCCESS");
                setValues({ name: "", email: "", role: "", message: "" }); // Clear fields
            },
            (error) => {
                console.log(error.text);
                setStatus("ERROR");
            }
        );
};

useEffect(() => {
    if (status === "SUCCESS") {
        setTimeout(() => {
            setStatus("");
            window.location.reload();
        }, 2000);
    }
}, [status]);

  

  return (
    <div className="contact-form-container">
    <div className="contact-form-title">お問い合わせ</div>
    {status === "SUCCESS" && (
      <div className="contact-form-success">送信しました！</div>
    )}
    {error && (
      <div className="contact-form-error">{error}</div>
    )}
    <form className="contact-form" ref={form} onSubmit={sendEmail}>
      <label>
        お名前
        <input
          name="name"
          type="text"
          placeholder="例：大阪 太郎"
          value={values.name}
          onChange={handleChange}
        />
      </label>
      <label>
        メール
        <input
          name="email"
          type="email"
          placeholder="例：mail@gmail.com"
          value={values.email}
          onChange={handleChange}
        />
      </label>
      <label>
        お問い合わせ内容
        <select
          name="role"
          value={values.role}
          onChange={handleChange}
        >
          <option value="">選択してください</option>
          <option value="問い合わせ">問い合わせ</option>
          <option value="見積もり">見積もり</option>
          <option value="その他">その他</option>
        </select>
      </label>
      <label>
        こちらにメッセージ書いてください
        <textarea
          name="message"
          value={values.message}
          onChange={handleChange}
          rows={4}
        />
      </label>
      <button type="submit">送信</button>
    </form>
  </div>
  );
};


